module.exports = __webpack_public_path__ + "static/media/tondo.b74df8b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/fonts/tondo.svg
// module id = 947
// module chunks = 0